export default __webpack_public_path__ + "static/KY1-2ccbacc476c4f0251161d4ae62c6dfa1.png";